import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import queryClient from './lib/queryClient';
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard/Dashboard';
import Settings from './pages/Settings/Settings';
import Agents from './pages/Agents/Agents';
import CreateAgent from './pages/Agents/CreateAgent';
import AgentDetail from './pages/Agents/AgentDetail';
import Search from './pages/Search/Search';
import Produits from './pages/Produits/ProduitsConnected';
import AddProduct from './pages/Produits/AddProduct';
import EditProduct from './pages/Produits/EditProduct';
import BaseConnaissance from './pages/BaseConnaissance/BaseConnaissanceConnected';
import RagDocuments from './pages/Rag/DocumentsPage';
import RagChat from './pages/Rag/ChatPage';
import RagDashboard from './pages/Rag/RagDashboard';
import Commandes from './pages/Commandes/CommandesConnected';
import GestionVentes from './pages/Caisse/GestionVentes';
import Factures from './pages/Factures/FacturesConnected';
import Conversations from './pages/Conversations/ConversationsConnected';
import WhatsAppPage from './pages/WhatsApp/WhatsAppPage';
import Relances from './pages/Relances/Relances';
import Calendrier from './pages/Calendrier/Calendrier';
import CreditsHistory from './pages/Credits/CreditsHistory';
import TestConnection from './pages/TestConnection/TestConnection';
import Login from './pages/Login/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { SidebarProvider } from './contexts/SidebarContext';
import { ToastProvider } from './contexts/ToastContext';
import { OrdersRealtimeProvider } from './contexts/OrdersRealtimeContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './i18n/LanguageContext';
import { UserProvider } from './contexts/UserContext';

function App() {
  return (
    <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
    <LanguageProvider>
    <ThemeProvider>
    <ToastProvider>
    <SidebarProvider>
    <UserProvider>
    <OrdersRealtimeProvider>
      <Router>
        <Routes>
          {/* Routes publiques */}
          <Route path="/login" element={<Login />} />
          <Route path="/test-connection" element={<TestConnection />} />
          
          {/* Routes protégées avec MainLayout */}
          <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/agents" element={<Agents />} />
            <Route path="/agents/:id" element={<AgentDetail />} />
            <Route path="/search" element={<Search />} />
            <Route path="/produits" element={<Produits />} />
            <Route path="/base-connaissance" element={<BaseConnaissance />} />
            <Route path="/rag/documents" element={<RagDocuments />} />
            <Route path="/rag/chat" element={<RagChat />} />
            <Route path="/rag/dashboard" element={<RagDashboard />} />
            <Route path="/commandes" element={<Commandes />} />
            <Route path="/caisse" element={<GestionVentes />} />
            <Route path="/factures" element={<Factures />} />
            <Route path="/conversations" element={<Conversations />} />
            <Route path="/whatsapp" element={<WhatsAppPage />} />
            <Route path="/relances" element={<Relances />} />
            <Route path="/calendrier" element={<Calendrier />} />
            <Route path="/credits" element={<CreditsHistory />} />
            <Route path="/settings" element={<Settings />} />
          </Route>

          {/* Routes protégées sans MainLayout */}
          <Route path="/agents/create" element={<ProtectedRoute><CreateAgent /></ProtectedRoute>} />
          <Route path="/produits/add" element={<ProtectedRoute><AddProduct /></ProtectedRoute>} />
          <Route path="/produits/edit/:id" element={<ProtectedRoute><EditProduct /></ProtectedRoute>} />
        </Routes>
      </Router>
    </OrdersRealtimeProvider>
    </UserProvider>
    </SidebarProvider>
    </ToastProvider>
    </ThemeProvider>
    </LanguageProvider>
    {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
